import{a as t}from"./chunk-RAAYCPUM.js";function f(...n){return t(e,n)}var e=(n,i)=>n.endsWith(i);export{f as a};
